import { createContext, PropsWithChildren, ReactNode, useContext } from "react";

export interface BackendFormContextValue {
    footerContent: ReactNode | null;
    error: string | undefined;
    feedback: string | undefined;
}

const BackendFormContext = createContext<BackendFormContextValue>({
    footerContent: null,
    error: undefined,
    feedback: undefined,
});

/** Hook to access the current BackendForm context value. */
export default function useBackendFormContext(): BackendFormContextValue {
    return useContext(BackendFormContext);
}

/** Provides BackendForm context to all descendant components. */
export function BackendFormContextProvider({ children, value }: PropsWithChildren<{ value: BackendFormContextValue }>) {
    return <BackendFormContext.Provider value={value}>{children}</BackendFormContext.Provider>;
}
